export default __webpack_public_path__ + "9df09481e779ca1bdadeb5dc4641abde.glb";